export const DiscountCode = (json: IDiscountCode): IDiscountCodeModel => {
	const fromJSON = (json: IDiscountCode) => {
		const {
			created_at,
			updated_at,
			start_date,
			description_en,
			end_date,
			is_active,
			amount,
			amount_type,
			usages_left,
			usages_per_user,
			min_amount,
			max_amount,
			available_segments,
			app_types,
			configuration,
			coupon,
			...rest
		} = json

		return {
			...rest,
			createdAt: created_at,
			updatedAt: updated_at,
			descriptionEn: description_en,
			startDate: start_date ? new Date(start_date) : null,
			endDate: end_date ? new Date(end_date) : null,
			amount: amount_type === EDiscountCodeType.FIXED ? amount / 100 : amount,
			isActive: is_active,
			amountType: amount_type,
			usagesLeft: usages_left,
			usagesPerUser: usages_per_user,
			minAmount: min_amount,
			maxAmount: max_amount,
			availableSegments: available_segments,
			appTypes: app_types ?? [],
			configuration: configuration && {
				serviceIDs: configuration.service_ids,
				serviceTypeIDs: configuration.service_type_ids,
			},
			coupon: coupon ? CouponCode(coupon) : null,
		}
	}

	return { ...fromJSON(json) }
}

export const discountCodeToJSON = (obj: Partial<IDiscountCodeForm>): Partial<IDiscountCode> => {
	const {
		startDate,
		endDate,
		isActive,
		amount,
		descriptionEn,
		amountType,
		usagesLeft,
		usagesPerUser,
		minAmount,
		maxAmount,
		availableSegments,
		appTypes,
		configuration,
		...rest
	} = obj

	return {
		start_date: startDate,
		end_date: endDate,
		is_active: isActive,
		description_en: descriptionEn,
		amount: amountType === EDiscountCodeType.FIXED && amount ? amount * 100 : amount,
		amount_type: amountType,
		usages_left: usagesLeft,
		usages_per_user: usagesPerUser,
		min_amount: minAmount,
		max_amount: maxAmount,
		available_segments: availableSegments,
		app_types: appTypes,
		configuration: {
			service_ids: configuration?.serviceIDs,
			service_type_ids: configuration?.serviceTypeIDs,
		},
		...rest,
	}
}

export const CouponCode = (json: ICouponCode): ICouponCodeModel => {
	const fromJSON = (json: ICouponCode) => {
		const { couponable, couponable_id, couponable_type, is_active, user_id, created_at, updated_at, ...rest } = json

		return {
			...rest,
			couponable: couponable ? DiscountCode(couponable) : null,
			couponableID: couponable_id,
			couponableType: couponable_type,
			isActive: is_active,
			userID: user_id,
			createdAt: created_at ? new Date(created_at) : null,
			updatedAt: updated_at ? new Date(updated_at) : null,
		}
	}

	return { ...fromJSON(json) }
}

export const DiscountCodeUsage = (json: ICouponCodeUsage): ICouponCodeUsageModel => {
	const fromJSON = (json: ICouponCodeUsage) => {
		const { created_at, updated_at, user, booking, coupon_id, ...rest } = json

		return {
			...rest,
			createdAt: created_at ? new Date(created_at) : null,
			updatedAt: updated_at ? new Date(updated_at) : null,
			user: user ? User(user) : null,
			booking: booking ? Booking(booking) : null,
			couponID: coupon_id,
		}
	}

	return { ...fromJSON(json) }
}
